<button
  class="container diamond-shape"
  [ngClass]="{ selected: isSelected }"
  [attr.aria-label]="day + ' - ' + (isSelected ? 'Selected' : 'Not Selected')"
  (click)="reminderDay.emit(day)">
  <!-- TODO: Need to translate longName and then grab first 2 letters -->
  <span class="day" aria-hidden="true">{{ DateTimeUtil.weekDaysData()[day]?.shortName }}</span>
</button>
